import { chakra } from '@chakra-ui/react';

export const IframeStyled = chakra('iframe', {
    baseStyle: {
        border: 'none',
        w: '100%',
        h: 'calc(100vh - 60px)'
    }
});
